const BenchmarkGauge = ({ current, target, label, size = "md" }) => {
  const percentage = Math.min((current / target) * 100, 150);
  const normalizedPercentage = Math.min(percentage, 100);
  
  // SVG dimensions based on size
  const sizes = {
    sm: { width: 120, height: 70, strokeWidth: 8, fontSize: 14 },
    md: { width: 160, height: 90, strokeWidth: 10, fontSize: 18 },
    lg: { width: 200, height: 110, strokeWidth: 12, fontSize: 22 },
  };
  
  const { width, height, strokeWidth, fontSize } = sizes[size];
  const radius = (width - strokeWidth * 2) / 2;
  const circumference = Math.PI * radius;
  
  // Calculate the stroke offset
  const offset = circumference - (normalizedPercentage / 100) * circumference;
  
  // Determine color based on percentage
  const getColor = () => {
    if (percentage >= 100) return "#10b981"; // emerald
    if (percentage >= 85) return "#f59e0b"; // amber
    return "#f43f5e"; // rose
  };
  
  const color = getColor();
  
  return (
    <div className="flex flex-col items-center" data-testid={`gauge-${label?.toLowerCase().replace(/\s+/g, "-")}`}>
      <svg width={width} height={height} className="overflow-visible">
        {/* Background arc */}
        <path
          d={`M ${strokeWidth} ${height - strokeWidth} A ${radius} ${radius} 0 0 1 ${width - strokeWidth} ${height - strokeWidth}`}
          fill="none"
          stroke="#475569"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
        />
        {/* Filled arc */}
        <path
          d={`M ${strokeWidth} ${height - strokeWidth} A ${radius} ${radius} 0 0 1 ${width - strokeWidth} ${height - strokeWidth}`}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 0.5s ease-out" }}
        />
        {/* Current value */}
        <text
          x={width / 2}
          y={height - strokeWidth - 10}
          textAnchor="middle"
          className="font-bold fill-foreground"
          style={{ fontSize, fontFamily: "Manrope" }}
        >
          {current.toFixed(1)}%
        </text>
      </svg>
      
      {/* Target indicator */}
      <div className="flex items-center gap-2 mt-2">
        <span className="text-xs text-muted-foreground">Target:</span>
        <span className="text-xs font-medium text-foreground">{target}%</span>
      </div>
      
      {/* Label */}
      {label && (
        <span className="text-xs font-semibold text-muted-foreground mt-1 uppercase tracking-wider">
          {label}
        </span>
      )}
    </div>
  );
};

export default BenchmarkGauge;
